import {Injectable} from '@angular/core';
import { LocalSettingsService } from 'shared/local-settings/local-settings.service';

import {from, Observable} from 'rxjs';

import {Credentials} from '../model/interfaces';

@Injectable()
export class CredentialsService {

  constructor(private localSettingsService: LocalSettingsService) { }

  public hasCredentials(): Observable<boolean> {
    return from (this.localSettingsService.get('credentials').then((cred) => {
      return cred !== null;
    }));
  }

  public getCredentials(): Observable<Credentials> {
    return from(this.localSettingsService.get('credentials').then((cred) => {
      if ( cred.password && cred.password.indexOf('\\u') === 0) {
        cred.password = this.unhexValue(cred.password);
      }
      return cred;
    }));
  }

  public saveCredentials(username: string, password: string): Promise<boolean> {
    return this.localSettingsService.set('credentials', {
        username: username,
        password: this.hexValue(password)});
  }

  public removeCredentials(): Promise<boolean> {
    return this.localSettingsService.del('credentials');
  }

  private hexValue(s: string): string {
    const arr: Array<string> = [];
    for (let i: number = 0; i < s.length; i++) {
      arr[i] = ('00' + s.charCodeAt(i).toString(16)).slice(-4);
    }
    return '\\u' + arr.join('\\u');
  }

  private unhexValue(s: string): string {
    return s.substring(2).split('\\u').map(a => String.fromCodePoint(parseInt(a, 16))).join('');
  }

}
